import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
// import "../../assets/css/style.css";
//import "../../assets/css/bootstrap.min.css";
import Header from "../../components/UserHeaer.jsx";
import { ref, uploadBytes } from "firebase/storage";
import Swal from "sweetalert2";
import { storage } from "./firebase";
import Select from "react-select";

function CreatePost() {
  const [imageUpload, setImageUpload] = useState(null);
  const [types, setTypes] = useState(null);
  const [categories, setCategory] = useState(null);
  const [wifi, setWifi] = useState(null);
  const [image, setImage] = useState("");
  const [selectedType, setSelectedType] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedWifi, setSelectedWifi] = useState();
  const [address, setAddress] = useState();
  const [price, setPrice] = useState();
  const [area, setArea] = useState();
  const [numberOfDep, setNymberOfBed] = useState();
  const [numberOfBath, setNymberOfBath] = useState();
  const [numberOfPeo, setNumberOfPeo] = useState();
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [canCreate, setCanCreate] = useState(true);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const userId = localStorage.getItem("Id");
  var role = localStorage.getItem("Role");

  const categoriesList = categories?.map((category) => {
    return { value: category.categoryId, label: category.categoryName };
  });

  const typesList = types?.map((type) => {
    return { value: type.typeId, label: type.typeName };
  });
  const wifiList = [
    { value: 1, label: 'Có' },
    { value: 0, label: 'Không' },
  ];

  const handleSelectType = (data) => {
    setSelectedType(data);
  };
  const handleSelectCategory = (data) => {
    setSelectedCategory(data);
  };

  const handleSelectWifi = (data) => {
    setSelectedWifi(data);
  };

  const handleImageClick = () => {
    inputRef.current.click();
  };
  const handleImageChange = (e) => {
    setImageUpload(e.target.files[0]);
    setImage(e.target.files[0]);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };
  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };
  const handleNumberOfBedChange = (event) => {
    setNymberOfBed(event.target.value);
  };
  const handleNumberOfBathChange = (event) => {
    setNymberOfBath(event.target.value);
  };
  const handleNumberOfPeohChange = (event) => {
    setNumberOfPeo(event.target.value);
  };
  const handleAreaChange = (event) => {
    setArea(event.target.value);
  };

  const canCreatefnc = async () => {
    const res = await fetch("https://trototbe.azurewebsites.net/api/Posts/canCreate", {
      mode: "cors",
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    if (res.status === 200) {
      const data = await res.json();
      setCanCreate(data);
    } else {
      const data = await res.text();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data,
      });
    }
  };

  const fetchCategoryData = async () => {
    const res = await fetch("https://trototbe.azurewebsites.net/api/Categories/all", {
      mode: "cors",
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    if (res.status === 200) {
      const data = await res.json();
      setCategory(data);
    } else {
      const data = await res.text();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data,
      });
    }
  };

  const fetchTypeData = async () => {
    const res = await fetch("https://trototbe.azurewebsites.net/api/Types/all", {
      mode: "cors",
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    if (res.status === 200) {
      const data = await res.json();
      setTypes(data);
    } else {
      const data = await res.text();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(selectedCategory == undefined){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Bạn chưa chọn loại bài đăng!",
      });
      return;
    }
    if(selectedType == undefined){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Bạn chưa chọn loại phòng!",
      });
      return;
    }
    if(selectedWifi == undefined){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Hãy chọn phòng có lắp đặt wifi hay không!",
      });
      return;
    }
    let imageData = "";
    if (selectedCategory.value === 2) {
      const imageRef = ref(storage, `images/${imageUpload.name}`);
      imageData =
        "https://firebasestorage.googleapis.com/v0/b/recipeorganizer-98c9b.appspot.com/o/images%2F" +
        imageUpload.name +
        "?alt=media";
      uploadBytes(imageRef, imageUpload).then(() => { });
    } else {
      imageData =
        "https://firebasestorage.googleapis.com/v0/b/recipeorganizer-98c9b.appspot.com/o/rooms%2Fno-image.jpg?alt=media";
    }
    const res = await fetch("https://trototbe.azurewebsites.net/api/Posts/create", {
      mode: "cors",
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({
        title: title,
        description: description,
        image: imageData,
        address: address,
        price: price,
        area: area,
        baths: numberOfBath,
        beds: numberOfDep,
        numberOfPeople: numberOfPeo,
        wifi: selectedWifi.value,
        categoryId: selectedCategory.value,
        typeId: selectedType.value,
      }),
    });
    if (res.status === 200) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Tạo thành công, vui lòng chờ phê duyệt!",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate("/home");
    } else {
      const data = await res.text();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data,
      });
    }
  };

  useEffect(() => {
    if (localStorage) {
      if (role !== "User" && role !== "Vip") {
        navigate("/");
      } else {
        fetchTypeData();
        fetchCategoryData();
        canCreatefnc();
      }
    }
  }, []);

  return (
    <div>
      <Header />
      <div className="py-5 px-10">
        <div>
          <div className="text-center">
            <h1 className="text-center uppercase font-bold text-2xl">
              Trọ Tốt
            </h1>
            <h1 className="mb-5">
              <span className="uppercase">
                Hãy đăng bài để tìm bạn cùng phòng phù hợp với bản thân!
              </span>
            </h1>
          </div>
          <div>
            {canCreate ? (
              <div>
                <div className="w-1/3" style={{ marginBottom: 20 }}>
                  <div>
                    <Select
                      required
                      className=""
                      options={categoriesList}
                      placeholder="Loại bài đăng"
                      value={selectedCategory}
                      onChange={handleSelectCategory}
                    />
                    {/* <label htmlFor="message">Loại phòng trọ</label> */}
                  </div>
                </div>
                <form>
                  {selectedCategory?.value === 2 ? (
                    <div>
                      <div>
                        <div>
                          <div>
                            <div>
                              <div>
                                <input
                                  required
                                  maxLength={50}
                                  type="text"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="title"
                                  placeholder="Tiêu đề"
                                  onChange={handleTitleChange}
                                />
                                {/* <label htmlFor="title">Tiêu đề</label> */}
                              </div>
                            </div>

                            <div className="w-1/3 inline-block">
                              <div className="w-full">
                                <input
                                  required
                                  min={0}
                                  type="number"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="area"
                                  placeholder="Diện tích"
                                  onChange={handleAreaChange}
                                />
                                {/* <label htmlFor="area">Diện tích</label> */}
                              </div>
                            </div>

                            <div className="w-1/3 inline-block ml-3">
                              <div className="w-full">
                                <input
                                  required
                                  min={0}
                                  type="number"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0 inline-block"
                                  id="price"
                                  placeholder="Giá tiền"
                                  onChange={handlePriceChange}
                                />
                                {/* <label htmlFor="price">Giá tiền</label> */}
                              </div>
                            </div>

                            <div>
                              <div className="w-1/4 inline-block">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    max={10}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfBed"
                                    placeholder="Số phòng ngủ"
                                    onChange={handleNumberOfBedChange}
                                  />
                                  {/* <label htmlFor="numberOfBed">Số phòng ngủ</label> */}
                                </div>
                              </div>

                              <div className="w-1/4 inline-block ml-3">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    max={10}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfBath"
                                    placeholder="Số phòng vệ sinh"
                                    onChange={handleNumberOfBathChange}
                                  />
                                  {/* <label htmlFor="numberOfBath">
                                    Số phòng vệ sinh
                                  </label> */}
                                </div>
                              </div>

                              <div className="w-1/4 inline-block ml-3">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfPeople"
                                    placeholder="Số người hiện tại"
                                    onChange={handleNumberOfPeohChange}
                                  />
                                  {/* <label htmlFor="numberOfPeople">
                                    Số người hiện tại
                                  </label> */}
                                </div>
                              </div>
                            </div>
                            <div className="w-full">
                              <div className="w-full">
                                <input
                                  required

                                  type="text"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="address"
                                  placeholder="Địa chỉ"
                                  onChange={handleAddressChange}
                                />
                                {/* <label htmlFor="address">Địa chỉ</label> */}
                              </div>
                            </div>

                            <div className="w-full mb-3">
                              <div className="w-full">
                                <Select
                                  required
                                  className=""
                                  options={typesList}
                                  placeholder="Loại phòng"
                                  value={selectedType}
                                  onChange={handleSelectType}
                                />
                                {/* <label htmlFor="message">Loại phòng trọ</label> */}
                              </div>
                            </div>

                            <div className="w-full mb-3">
                              <div className="w-full">
                                <Select
                                  required
                                  className=""
                                  options={wifiList}
                                  placeholder="Wifi"
                                  value={selectedWifi}
                                  onChange={handleSelectWifi}
                                />
                              </div>
                            </div>

                            <div className="w-full">
                              <div className="w-full">
                                <textarea
                                  required
                                  className="w-full rounded py-3 px-3 mb-3 border outline-0"
                                  placeholder="Mô tả"
                                  id="description"
                                  style={{ height: "100px" }}
                                  onChange={handleDescriptionChange}
                                ></textarea>
                                {/* <label htmlFor="description">Mô tả</label> */}
                              </div>
                            </div>
                            <div
                              className="w-full"
                            >
                              <div>
                                <label htmlFor="image">Đăng tải hình ảnh: </label>
                                <br></br>
                                <br></br>
                                <input
                                  required
                                  type="file"
                                  id="image"
                                  style={{ height: "50px" }}
                                  className="w-full"
                                  onChange={handleImageChange}
                                  ref={inputRef}
                                /> {image && (
                                  <img
                                  src={URL.createObjectURL(image)} alt="..."                              
                                    style={{ width: "50%", height: "50%" }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-full">
                      <div className="w-full">
                        <div>
                          <div className="w-full">
                            <div className="w-full">
                              <div>
                                <input
                                  required
                                  maxLength={50}
                                  type="text"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="title"
                                  placeholder="Tiêu đề"
                                  onChange={handleTitleChange}
                                />
                                {/* <label htmlFor="title">Tiêu đề</label> */}
                              </div>
                            </div>

                          
                            <div className="w-1/3 inline-block">
                              <div className="w-full">
                                <input
                                  required
                                  min={0}
                                  type="number"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="area"
                                  placeholder="Diện tích"
                                  onChange={handleAreaChange}
                                />
                                {/* <label htmlFor="area">Diện tích</label> */}
                              </div>
                            </div>

                            <div className="w-1/3 inline-block ml-3">
                              <div className="w-full">
                                <input
                                  required
                                  min={0}
                                  type="number"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0 inline-block"
                                  id="price"
                                  placeholder="Giá tiền"
                                  onChange={handlePriceChange}
                                />
                                {/* <label htmlFor="price">Giá tiền</label> */}
                              </div>
                            </div>

                            <div>
                              <div className="w-1/4 inline-block">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    max={10}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfBed"
                                    placeholder="Số phòng ngủ"
                                    onChange={handleNumberOfBedChange}
                                  />
                                  {/* <label htmlFor="numberOfBed">Số phòng ngủ</label> */}
                                </div>
                              </div>

                              <div className="w-1/4 inline-block ml-3">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    max={10}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfBath"
                                    placeholder="Số phòng vệ sinh"
                                    onChange={handleNumberOfBathChange}
                                  />
                                  {/* <label htmlFor="numberOfBath">
                                    Số phòng vệ sinh
                                  </label> */}
                                </div>
                              </div>

                              <div className="w-1/4 inline-block ml-3">
                                <div className="w-full">
                                  <input
                                    required
                                    min={0}
                                    type="number"
                                    className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                    id="numberOfPeople"
                                    placeholder="Số người hiện tại"
                                    onChange={handleNumberOfPeohChange}
                                  />
                                  {/* <label htmlFor="numberOfPeople">
                                    Số người hiện tại
                                  </label> */}
                                </div>
                              </div>
                              </div>

                            <div className="w-full">
                              <div className="w-full">
                                <input
                                  required
                                  type="text"
                                  className="w-full h-[50px] rounded px-3 mb-3 border outline-0"
                                  id="address"
                                  placeholder="Địa chỉ"
                                  onChange={handleAddressChange}
                                />
                                {/* <label htmlFor="address">Địa chỉ</label> */}
                              </div>
                            </div>

                            <div className="w-full mb-3">
                              <div className="w-full">
                                <Select
                                  required
                                  className=""
                                  options={typesList}
                                  placeholder="Loại phòng"
                                  value={selectedType}
                                  onChange={handleSelectType}
                                />
                                {/* <label htmlFor="message">Loại phòng trọ</label> */}
                              </div>
                            </div>

                            <div className="mb-3">
                              <div>
                                <Select
                                  required
                                  className=""
                                  options={wifiList}
                                  placeholder="Wifi"
                                  value={selectedWifi}
                                  onChange={handleSelectWifi}
                                />
                              </div>
                            </div>

                            <div className="w-full">
                              <div className="w-full">
                                <textarea
                                  required
                                  className="w-full rounded px-3 py-3 mb-3 border outline-0"
                                  placeholder="Mô tả"
                                  id="description"
                                  style={{ height: "50px" }}
                                  onChange={handleDescriptionChange}
                                ></textarea>
                                {/* <label htmlFor="description">Mô tả</label> */}
                              </div>
                            </div>

                            {/* <input
                          type="file"
                          
                          className="form-control"
                          id="area"
                          style={{ height: "100px" }}
                          onChange={handleImageChange}
                          ref={inputRef}
                        /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="text-right">
                    <button
                      onClick={handleSubmit}
                      className="w-full py-3 bg-green-600 px-5 text-white font-bold hover:bg-green-500 rounded"
                      type="submit"
                      style={{
                        marginTop: 20
                      }}
                    >
                      Đăng bài
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div className="alert-message"
                style={{
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                  padding: "10px",
                  border: "1px solid #f5c6cb",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  alignContent: "center"
                }}
              >
                Bạn đã hết lượt đăng bài miễn phí</div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default CreatePost;
